<template>
<div class="content" id="targets">
  <form @submit.prevent>
  <table id="targetslist">
    <thead>
      <tr><th>{{category}} Targets</th><th>Edit</th><th>x</th></tr>
    </thead>
    <tbody>
      <tr v-for="target in targetListItems" :key="target.id">
        <td>{{target.from}} &rarr; {{target.to}}</td>
        <td><a href="#" @click="editTarget(category, target.from, target.to, $event)" class="btnedit">&nbsp;</a></td>
        <td><a href="#" @click="deleteTarget(category, target.from, $event)" class="btndelete">&nbsp;</a></td>
        </tr>
       <tr v-if="npages==0">
        <td colspan="3">No target item found</td>
      </tr>
    </tbody>
  </table>
  <list-pagination v-if="npages>1" :npages="npages" :cursor="cursor" @showpage="loadPage" />
  </form>
</div>
</template>
<script>
import { mapActions } from "vuex";
import ListPagination from '@/components/ListPagination'
import dateHelper from '@/helpers/dateHelper'

export default {
  components:{
    ListPagination,
  },
  data(){
    return {
      cursor:0,
      limit: 25,
      error:{},
      targetListItems:[]
    }
  },
  computed:{
    npages(){
      const items=this.$store.state.targetStore['targetslist'][this.category];
      if(items && items.length>0){
        return Math.ceil(items.length/this.limit)
      }
      return 0;
    },

    category(){
      return this.$route.params.category;
    },
    date(){
      return dateHelper.getDisplayDate()
    }

  },
  watch:{
    category(){
      this.loadTargetsList();
    },
    cursor(){
      const items=this.$store.state.targetStore['targetslist'][this.category];
      if(!items || items.length==0){return [];}
      const start=this.limit * this.cursor;
      const end=start+ this.limit;
      
      this.targetListItems= items.slice(start, end)
    }
  },
  //
  methods:{
    ...mapActions('targetStore', ['initCurrentCategoryTargets', 'fetchTargetsList', 'deleteCategoryTargets']),
    //
    editTarget(category, from, to, evt){
      evt.preventDefault();
      //
      this.initCurrentCategoryTargets({category, from, to})
      //console.log('About to edit target:', category+'-'+from)
      this.$router.push('/targets/edit/'+category+'/'+from)
    },
    //
    deleteTarget(category, from, evt){
      evt.preventDefault();
      if(confirm(`Are you sure you want to delete theses ${category} targets?`)){
        //console.log('About to delete target:', category+'-'+from)
        const payload={category, from}
        this.deleteCategoryTargets(payload, {rootStore:true})
      }
    },
    //handles "loadpage" event from "ListPagination" component 
    loadPage(pageNumber){
      //console.log('TargetsList loading page ', pageNumber);
      this.cursor=pageNumber
    },
    //
    loadTargetsList(){
      //Targets List already downloaded
      if(Object.keys(this.$store.state.targetStore.targetslist).length>0){
        this.targetListItems={...this.$store.state.targetStore['targetslist'][this.category]}
        return;
      }

      const date=dateHelper.getFirstDay(this.category, this.date)
      const payload={category: this.category, date }
      this.fetchTargetsList(payload, {rootStore:true}).then(() => {
        this.targetListItems={...this.$store.state.targetStore['targetslist'][this.category]}
        console.log('Target List Items:', this.targetListItems)
      }).catch(error => {
        this.showErrorMessage('Error while fetching targets list:'+error.message)
      })
    },
    showErrorMessage(message, type='alert'){
      this.error={message, type}
    }
  },
  //
  beforeMount (){
    this.error={message:'', type:'alert'}
    this.loadTargetsList()
  }
}
</script>
